import { render, staticRenderFns } from "./HomeScroll.vue?vue&type=template&id=1b013ae4&"
import script from "./HomeScroll.vue?vue&type=script&lang=js&"
export * from "./HomeScroll.vue?vue&type=script&lang=js&"
import style0 from "./HomeScroll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports